import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import ReusableModal from "../../Components/Modal";
import { Modal } from "react-bootstrap";

const Categories = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [catId, setCatId] = useState({});

  const closeModal = () => {
    setCatId({});
    setShowModal(false);
  };
  useEffect(() => {
    fetchCategory(pageData.currentPage, entries);
  }, [pageData.currentPage, entries]);

  const fetchCategory = async (current, count) => {
    setLoading(true);
    try {
      const getCategoryList = await axiosHttp.get(
        `skill-categories?page=${current}&count=${count}`
      );
      if (getCategoryList.status === 200) {
        let data = getCategoryList.data.data;
        let page = getCategoryList.data.meta;
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setCategoryList(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setCategoryList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const postCategory = await axiosHttp.post(
        catId.id ? `skill-categories/${catId.id}` : `skill-categories`,
        { categoryName: catId.name }
      );
      if (postCategory.status === 200 || postCategory.status === 201) {
        fetchCategory(pageData.currentPage, entries);
        setShowModal(false);
        setCatId({});
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setCategoryList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteCategory = await axiosHttp.delete(`skill-categories/${id}`);
      if (deleteCategory.status === 200) {
        setLoading(true);
        toast.success(deleteCategory.data.message);
        fetchCategory(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const updateEntries = (e) => {
    let entryNumber = Number(e.target.value);
    setEntries(entryNumber);
  };

  const handleModal = (cat) => {
    setCatId(cat);
    setShowModal(true);
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-5">Category Details</h4>

          <div className="row">
            <div className="col-md-5">
              <h5 className="head">Categories List</h5>
            </div>
            <div className="col-md-7 text-right">
              <button
                type="button"
                className="btn btn-primary "
                onClick={() => setShowModal(true)}
              >
                Add Category
              </button>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={updateEntries}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th className="border-right-0 ">
                    <input
                      type="checkbox"
                      className="form-control check-box "
                    />
                  </th>
                  <th>Category</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categoryList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {categoryList.length > 0 &&
                  categoryList.map((admin) => {
                    return (
                      <tr key={admin.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td className="border-right-0 ">{admin?.name}</td>
                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEdit}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => handleModal(admin)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(admin.id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title={
          Object.entries(catId).length !== 0
            ? "Update Category"
            : "Add Category"
        }
        size="md"
      >
        <Modal.Body>
          <div className="form-group input-group mb-5">
            <label className="has-float-label">
              <input
                className="form-control"
                type="text"
                value={catId?.name || ""}
                name="name"
                onChange={(e) => setCatId({ ...catId, name: e.target.value })}
              />
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Footer className="mt-4 justify-content-center">
            <button
              type="button"
              className="btn btn-outline-primary modal-btn"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary modal-btn"
              onClick={closeModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal.Footer>
      </ReusableModal>
    </div>
  );
};

export default Categories;
